document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.brand-directory').forEach(function (root) {
    var input = root.querySelector('.brand-directory__search-input');
    if (!input) return;

    var items = Array.prototype.slice.call(root.querySelectorAll('.brand-directory__item'));
    var noResults = root.querySelector('.brand-directory__no-results');
    var countEl = root.querySelector('[data-brand-count]');
    var countTemplate = countEl ? countEl.textContent : '';

    var filter = function () {
      var query = input.value.trim().toLowerCase();
      var totalVisible = 0;

      items.forEach(function (item) {
        var name = item.getAttribute('data-brand-name') || '';
        var match = query === '' || name.indexOf(query) !== -1;
        item.hidden = !match;
        if (match) totalVisible += 1;
      });

      if (noResults) {
        noResults.hidden = totalVisible !== 0;
      }

      if (countEl) {
        countEl.textContent = query === ''
          ? countTemplate
          : totalVisible + ' / ' + items.length + ' brands';
      }
    };

    input.addEventListener('input', filter);
  });
});
